@if (isExportMode) {
  <h2 class="ps-2 detailsHeader" translate="CloudLocations.ExportDetails"></h2>
  @if (isForAutoExport) {
    <div class="py-2 m-2 autoExportSwitch form-switch">
      <input class="switch-form-default form-check-input col-2" type="checkbox" role="switch" id="setBrandingStatus"
        name="setBrandingStatus" [ngModel]="isForAutoExport" disabled>
        <label class="form-check-label pt-1 col-10" for="authenticatorapp"
        translate="CloudLocations.UseAutoExport"></label>
      </div>
    }
    <div class="p-2">
      <span class="fw-normal" translate="CloudLocations.ExportMethod"></span>
      <div ngbDropdown class="mt-1 dropdown w-100" [(ngModel)]="selectedOption" ngDefaultControl name="exportMethod" id="exportMethod">
        <button class="btn exportMethods text-truncate" type="button" id="dropdownMenu" ngbDropdownToggle>
          {{ 'CloudLocations.ExportType.' + selectedOption | translate }}
          <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
        </button>
        <div ngbDropdownMenu class="w-100" aria-labelledby="dropdownMenu" data-testid="dropdownMenuExportMethods">
          @for (method of exportMethods; track method) {
            <button ngbDropdownItem [value]="method.value"
              [disabled]="disableExportOption(method.value)"
              (click)="changeExportMethod($event)"
            [translate]="'CloudLocations.ExportType.' + method.label"></button>
          }
        </div>
      </div>
    </div>
    @if (showFileNameInput()) {
      <div class="p-2">
        @if (selectedOption === exportMethodsEnum.Zip) {
          <span class="fw-normal" translate="CloudLocations.NameForZip"></span>
        }
        @if (selectedOption === exportMethodsEnum.Folder) {
          <span class="fw-normal" translate="CloudLocations.NameForFolder"></span>
        }
        <input type="text" class="mt-1 form-control" [(ngModel)]="fileName" name="fileName" id="fileName" required>
      </div>
    }
    @if (isHyarchisWithDocuments()) {
      <div class="p-2">
        <span class="fw-normal" translate="CloudLocations.ChecklistItem"></span>
        <div class="w-100 mb-0 pt-1 d-inline-block">
          @for (document of documentsToExport; track document; let first = $first; let last = $last) {
            <app-cloud-export-checklist-item
              [disabled]="checklistItems.length === 0"
              [document]="document"
              [checklistItems]="checklistItems"
              [firstItem]="first"
              [lastItem]="last">
            </app-cloud-export-checklist-item>
          }
        </div>
      </div>
    }
  }

  @if (!isExportMode) {
    <div>
      <h2 class="ps-2 detailsHeader" translate="CloudLocations.SelectedFiles"></h2>
      <ul class="list-group selectedFilesList cursor-pointer rounded-0">
        @for (file of selectedFiles; track file) {
          <li
            class="list-group-item cloudlocations d-flex justify-content-between align-items-center border-top-0 border-start-0 border-end-0">
            <div class="col-9 text-truncate">
              <span>{{file.name}}</span>
            </div>
            <div class="col-3 text-truncate cursor-pointer" (click)="removeFile(file)">
              <i class="bi bi-x-lg bi-large float-end deleteIcon"></i>
            </div>
          </li>
        }
      </ul>
    </div>
  }

  <span class="float-end">
    @if (isExportMode) {
      <button class="btn btn-sm btn-primary m-2"
        (click)="export()"
        [disabled]="isExportDisabled"
        translate="Button.Export">
      </button>
    }
    @if (!isExportMode) {
      <button class="btn btn-sm btn-primary m-2"
        (click)="import()"
        [disabled]="!hasSelectedFiles"
        translate="Button.Import">
      </button>
    }
  </span>
